import type { FilesKeyframeSchemaWithIdNullable } from '@iconik-io/iconik-api/src/services/files';

import { KEYFRAME, KEYFRAME_MAP } from './constants';

export const isClosed = (keyframe: FilesKeyframeSchemaWithIdNullable) =>
  keyframe.status === 'CLOSED';

export const isKeyframe = (keyframe: FilesKeyframeSchemaWithIdNullable) =>
  keyframe.type === KEYFRAME && isClosed(keyframe);

export const hasKeyframeMap = (
  keyframes: FilesKeyframeSchemaWithIdNullable[],
) => keyframes.some((keyframe) => keyframe.type === KEYFRAME_MAP);

export const isKeyframeMap = (
  keyframe: FilesKeyframeSchemaWithIdNullable,
): boolean => keyframe.type === KEYFRAME_MAP && isClosed(keyframe);

export const findKeyframeUrl = (
  keyframes: FilesKeyframeSchemaWithIdNullable[] = [],
): string | undefined => {
  let url;
  const item = keyframes.find(isKeyframe);
  if (item && item.url) {
    url = item.url;
  }
  return url;
};

export const getCustomKeyframe = (
  keyframes: FilesKeyframeSchemaWithIdNullable[],
): FilesKeyframeSchemaWithIdNullable | undefined => {
  if (hasKeyframeMap(keyframes)) {
    return undefined;
  }
  return keyframes.find(
    (keyframe) => keyframe.is_custom_keyframe && keyframe.type === 'KEYFRAME',
  );
};

export const findCollectionKeyframeUrl = (
  keyframes: FilesKeyframeSchemaWithIdNullable[] = [],
): string | undefined => keyframes.find(isKeyframeMap)?.url ?? undefined;

export const getKeyframeType = (
  keyframes: FilesKeyframeSchemaWithIdNullable[] = [],
): 'KEYFRAME_MAP' | 'KEYFRAME' | undefined => {
  if (
    keyframes.some((keyframe) => isKeyframeMap(keyframe) && isClosed(keyframe))
  ) {
    return KEYFRAME_MAP;
  }
  if (
    keyframes.some((keyframe) => isKeyframe(keyframe) && isClosed(keyframe))
  ) {
    return KEYFRAME;
  }
  return undefined;
};
